import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { setExchangeIntoTiff, getTiffData, getExpectedExchangeDate } from "./actions";
import { fetchAccountData } from "../../../../../../actions/globalActions";
import TIFFViewAndEditFrom from "../../Components/TIFFViewAndEditFrom";
import { ViewEditFromTiffDerivedStates } from "./selectors";

const mapStateToProps = state => ({
  ...ViewEditFromTiffDerivedStates(state.toJS())
});

export const mapDispatchToProps = dispatch => ({
  setExchangeIntoTiff: data => dispatch(setExchangeIntoTiff(data)),
  getData: data => dispatch(getTiffData(data)),
  getExchangeDate: data => dispatch(getExpectedExchangeDate(data)),
  requestDataTiff: data => dispatch(fetchAccountData(data)),
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(TIFFViewAndEditFrom)
);
